import { WebSocketMessageTypeOutgoing } from "../../Enums/WebSocketMessageTypeOutgoing";

export class MessageWebSocketOutgoing {
    public Type?: WebSocketMessageTypeOutgoing;
    public SessionId?: string;

    constructor(){

    }
}